import { Component} from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';


@Component({
  selector: 'app-deduction-rates',
  templateUrl: './deduction-rates.component.html',
  styleUrls: ['./deduction-rates.component.scss'],
  standalone: true,
  imports: [RouterModule, MatIconModule, MatMenuModule, MatButtonModule, MatSelectModule, MatOptionModule],
})
export class DeductionRatesComponent {
    thisYear = new Date().getFullYear();

  constructor(

  ) {
  }

}
